/*
 * @FileDescription: 文件上传
 * @Author: wh
 * @Date: 2020-08-12 14:24:08
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-26 11:23:07
 */
export default {
  data() {
    return {
      filterType: '.pdf,.ppt,.pptx,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.zip'
    };
  },
  methods: {
    onReady() {},
    fileAdded(files) { // 文件被加入到队列
      const errorMsg = {
        'forbidden': this.$t('pc_ulcd_msg_fileformatincorrect'),
        'oversize': this.$t('pc_ulcd_msg_filesizeoutofrange')
      };
      let error = files[0].error;
      error && this.$error(errorMsg[error]);
    },
    beforeUpload(file) { // 某个文件开始上传事件，如果想阻止这个文件的上传，请返回 false，
      window.sessionStorage.setItem('ulcd_file_uploading', 1);
      if (this.files.length >= this.limit) { return false; }
      this._beforeUpload && this._beforeUpload(file);
      this.files.push({
        fileId: file.uuid, // 临时作为 fileId
        name: file.name,
        fileSize: file.size,
        fileType: file.fileType,
        fileClass: file.fileClass,
        percentage: 0,
        type: 0,
        loading: true,
        file // 缓存 file，用于终止上传
      });
    },
    onProgress(file, progress, event) { // 上传进度条事件
      let f = this.getFile(file);
      // eslint-disable-next-line radix
      f.percentage = parseInt(progress * 100);
    },
    onUploaded(file) { // 上传成功的事件
      let f = this.getFile(file);
      f.url = file.fullUrl;
      f.fileId = file.id;
      f.loading = false;
      delete f.file;
      console.log('onUploaded', file);
      window.sessionStorage.setItem('ulcd_file_uploading', 0);
    },
    onComplete() { // 队列里面的文件上传结束事件
      window.sessionStorage.setItem('ulcd_file_uploading', 0);
    },
    onError(error, file) { // 上传出错事件
      console.log(error);
      this.removeFile(file, 'uuid');
      window.sessionStorage.setItem('ulcd_file_uploading', 0);
    },
    getFile(file) {
      return this.files.find(item => item.fileId === file.uuid);
    },
    removeFile(file, key = 'fileId') {
      file.file && this.$refs['bizUpload'].remove(file.file);
      let index = this.files.findIndex(item => item.fileId === file[key]);
      if (index !== -1) {
        this.files.splice(index, 1);
      }
    },
    formatFiles(files) {
      return files.map(file => ({
        fileId: file.fileId,
        name: file.name,
        fileSize: file.fileSize,
        url: file.url,
        fileType: file.fileType,
        percentage: 100,
        type: file.type
      }));
    }
  },
  mounted() {
    window.sessionStorage.removeItem('ulcd_file_uploading');
  }
};
